import Vue from 'vue'
import VueAxiosPlugin from 'vue-axios-plugin'
import Element from 'element-ui'
import gg from './../gg'
Vue.use(VueAxiosPlugin, {
	// 请求拦截处理
	reqHandleFunc: config => {
		// config.baseURL = '/api';//开发版网址
		// config.baseURL = '/tp5/public';//打包后网址
		// config.baseURL = 'http://api.zhonghaoyi.cn'; //打包后网址
		config.baseURL = gg.fuwuqi; //打包后网址
		config.headers = gg.headers2;
		// config.headers = {
		// 	// 'Content-Type': 'application/json',
		// 	'shebei': 'liulanqi_diannao',
		// 	'renzhengma': '37c1fcf4ab61593978fb0bda44340953',
		// 	'loginkouling': localStorage.getItem("登录口令") || '',
		// 	'loginbianhao': localStorage.getItem("登录口令编号") || ''
		// };

		// `timeout` 指定请求超时的毫秒数(0 表示无超时时间)
		// 如果请求花费了超过 `timeout` 的时间，请求将被中断
		//config.timeout = 180000;
		config.timeout = 3600000;
		// `maxContentLength` 定义允许的响应内容的最大尺寸
		//config.maxContentLength = 2147483647;

		return config;
	},
	reErrorFunc: error => {
		console.log(error);
		Element.Message.error('网络错误2！');
		return Promise.reject(error);
	},
	// 响应拦截处理
	resHandleFunc: response => {
		// return response;
		if (response.data.代码 == "成功") {
			// res为服务端返回值，可能有code，result等字段
			// 这里对res.result进行返回，将会在this.$u.post(url).then(res => {})的then回调中的res的到
			// 如果配置了originalData为true，请留意这里的返回值
			return response.data;
		} else if (response.data.代码 == "认证失败") {
			Element.Message.error(response.data.信息);
			setTimeout(() => {
				window.location.replace("login.html");
			}, 1000)
			return false;
		} else if (response.data.代码 == "权限错误") {
			return response.data;
		} else if (response.data.代码 == "返回错误") {
			return response.data;
		} else if (response.data.代码 == "错误") {
			Element.Message.error(response.data.信息);
			return Promise.reject(response.data);
		} else {
			Element.Message.error(response.data);
			return Promise.reject(response.data);
		}
	},
	resErrorFunc: error => {
		console.log(error);
		Element.Message.error('网络错误3！');
		return Promise.reject(error);
	}
});

//import axios from 'axios'
//Vue.prototype.$http= VueAxiosPlugin
//VueAxiosPlugin.defaults.baseURL = '/api'
